import { jsx } from 'panel';
import pick from 'lodash/pick';
import { propagateEvent } from 'common/util/dom';
import { serializeAttributes } from 'common/util';
import { StagedCohortsQueryBuilderEl } from '../cohorts-query-builder';
import { QueryBuilderEl } from '../query-builder';
import { RowLabelType } from '../query-entry-section/types';
export function template() {
  var _a, _b;
  /**
   * To maintain backwards compatibility with the old builder
   * we render the staged cohorts editor and mirror its API
   *
   * Releasing the new cohorts builder would be a matter of dropping this conditional
   */


  if (!this.hasNewQBEnabled()) {
    const stagedCohortsAttrs = ["project-id", "project-has-cohorts", "data-group-id", "support-b2b-cohorts", "disabled", "hide-reset-button", "track-name", "user-id", "workspace-id", "project-as-of-date"];
    return jsx(StagedCohortsQueryBuilderEl, {
      attrs: serializeAttributes(Object.assign({
        elref: "stagedCohortBuilder",
        'staged-cohort': (_a = this.attr("staged-cohort")) !== null && _a !== void 0 ? _a : this.cohort.toStagedCohort().serialize()
      }, pick(this.attrs(), stagedCohortsAttrs))),
      on: {
        cohortUpdated: ev => propagateEvent(this, ev),
        stagedCohortUpdated: ev => propagateEvent(this, ev),
        track: ev => propagateEvent(this, ev)
      }
    });
  }

  return jsx("div", {
    sel: '.mp-cohorts-query-builder'
  }, jsx(QueryBuilderEl, {
    attrs: {
      entries: this.cohort.groups,
      // allows for per-line cohort filters as Insights does
      'allow-cohort-filter': true,
      'entry-row-label-type': RowLabelType.Alpha,
      'entries-draggable': true,
      'include-custom-properties': "all",

      /**
       * @todo [pablo] figure out how to slot in save controls content from this project:
       * https://www.notion.so/mpspeed/Design-proposal-v2-e04e0ec0edad422899eaee6372f195f3
       * */
      'header-title': "Criteria",
      'hide-date-picker': true,
      'hide-filter': true,
      'hide-group-by': true,

      /** @todo [pablo] enable this and have b2b validation be entirely owned by the query builder */
      'hide-data-groups-selector': true,
      'all-data-groups': true,
      'data-group-id': (_b = this.attr("data-group-id")) !== null && _b !== void 0 ? _b : "",
      'data-groups-enabled': this.attr("support-b2b-cohorts"),
      'max-data-history-days': this.attr("max-data-history-days"),
      'row-types': this.rowTypes,
      'support-b2b-cohorts': this.attr("support-b2b-cohorts"),
      'project-has-cohorts': this.attr("project-has-cohorts"),
      'track-name': this.attr("track-name"),
      'project-has-people': this.hasPeopleEnabled(),
      'project-as-of-date': this.attr("project-as-of-date"),
      'project-id': this.attr("project-id"),
      'workspace-id': this.attr("workspace-id"),
      'user-id': this.attr("user-id")
    },
    on: {
      update: ev => this.handleQueryUpdate(ev)
    }
  }));
}